import * as React from 'react';
import { UserToken } from '../../amorg-common';
import { CorePageWrapper } from '../../designSystem/layouts/pageWrappers/CorePageWrapper';
import { getMaybeActiveUserOrRefresh, redirectToLogin } from '../../api/serverApiHelpers';
import { ProtectedPageProvider } from '../_contexts/ProtectedPageContext';
import { NoNavigationPageWrapper } from '../../designSystem/layouts/pageWrappers/NoNavigationPageWrapper';
import { Flex } from '../../designSystem/compositeComponents/FlexHelpers';

type MemberPageWrapperProps = {
    allowUser?:boolean
    selectedMenuItemKey?:string,
    children: React.ReactNode
}

export const MemberPageWrapper: React.FunctionComponent<MemberPageWrapperProps> = (props:MemberPageWrapperProps) => 
{
    const [activeUser, setActiveUser] = React.useState<UserToken | null>(null);

    React.useEffect(() => {
        const handle = async () => {
            const result = await getMaybeActiveUserOrRefresh();
            if(result.tokenUser === null){
                redirectToLogin();
            }
            else{
                setActiveUser(result.tokenUser);
            }
        };
        handle();
    }, []);

    const validPermission = activeUser &&
        (
            (props.allowUser && activeUser.permissionGroupId === 'user') ||
            activeUser.permissionGroupId === 'member' ||
            activeUser.permissionGroupId === 'siteadmin' ||
            activeUser.permissionGroupId === 'superadmin'
        );

    return (
        <>
            {validPermission &&        
                <ProtectedPageProvider 
                    user={activeUser}>

                        <CorePageWrapper
                            activeUser={activeUser} 
                            loading={false}
                            hideMenu={false}
                            selectedMenuItemKey={props.selectedMenuItemKey}>

                            {props.children}

                        </CorePageWrapper>

                </ProtectedPageProvider>
            }

            {!validPermission &&
                <NoNavigationPageWrapper>

                    <Flex justifyContent='center' alignItems='center'>
                        <p>Hov! Du er havnet på en side, som du ikke har adgang til.</p>
                    </Flex>

                </NoNavigationPageWrapper>
            }
        </>
    )    
};